import { render, staticRenderFns } from "./classRewards.vue?vue&type=template&id=56162c5f&"
import script from "./classRewards.vue?vue&type=script&lang=js&"
export * from "./classRewards.vue?vue&type=script&lang=js&"
import style0 from "./classRewards.vue?vue&type=style&index=0&id=56162c5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports